import { gql } from '@apollo/client';

export const GET_CONFIG_ITEM = gql`
  query GetConfigItem($key: String!) {
    vm {
      configItem(key: $key) {
        configItemId
        key
        description
        defaultValue
        configItemValue {
          flagValue
        }
      }
    }
  }
`;